<template>
    <div class="flex items-center flex-col justify-center space-y-6 flex-1 rounded w-full h-full">
        <div class="relative flex items-center">
            <div
                class="text-red-500 italic absolute inset-0 -mt-6"
                v-text="$t('composer.validUrl')"
                v-if="linkIsInvalid"
            />
            <activix-input
                class="w-96"
                :placeholder="$t('composer.link')"
                ref="input"
                @keydown.enter="setLink"
                v-model="linkUrl"
            />
            <div class="flex items-center">
                <activix-button
                    tool
                    class="shadow-none border-l-0 border-r-0"
                    :disabled="!linkIsValid"
                    type="primary"
                    @click="setLink"
                >
                    {{ $t('composer.insert') }}
                </activix-button>
                <activix-button class="shadow-none border-l-0" @click="removeLink">
                    {{ $t('composer.unlink') }}
                </activix-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        emits: ['set-link'],

        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            selectedLink: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                linkUrl: '',
            };
        },

        computed: {
            linkIsValid() {
                return this.linkUrl && this.urlIsValid(this.linkUrl);
            },
            linkIsInvalid() {
                return this.linkUrl && !this.urlIsValid(this.linkUrl);
            },
        },

        methods: {
            setLink() {
                if (this.linkIsInvalid) {
                    return;
                }

                this.$emit('set-link', this.linkUrl);
            },

            removeLink() {
                this.linkUrl = '';
                this.setLink();
            },

            onClick() {
                if (this.$refs.input) {
                    this.$refs.input.focus();
                }
            },
        },

        mounted() {
            if (this.urlIsValid(this.selectedLink)) {
                this.linkUrl = this.selectedLink;
            }
        },
    };
</script>
